import { network } from 'services/network';

export const setCheckMandatorily = (params) => {
    return network.post('api/bo/setCheckMandatorily', params).then((response) => {
        return response.data;
    });
};
